import React, { useState } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import drag from "../../../assets/images/drag.svg";
import ph_question from "../../../assets/images/ph_question.svg";
import selected_question from "../../../assets/images/selected_question.svg";
import { Input, Select, Popover, Tooltip, notification, Checkbox } from "antd";
import trash from "../../../assets/images/trash.svg";
import { useTranslation } from "react-i18next";
import axios from "axios";
import environment from "environment";
import { forceLogout } from "utilities/HttpUtility";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const LineItem = (props) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.common.currentLanguage);

  const {
    treatments,
    treatmentId,
    handleConfirmationPopup,
    handleOnChangeItem,
    handleToggleItemSelection,
    selectedItems,
    isEdit,
    selectedPage,
    treatmentIndex,
    extracted_invoice_data
  } = props;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(null);
  // const [prevItem, setPrevItem] = useState();
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [openPopups, setOpenPopups] = useState({});
  const [customVAT, setCustomVAT] = useState({});
  const { id } = useParams();


  const handleOnChangeVAT = (e, itemKey) => {
    handleOnChangeItem(treatmentId, itemKey, "VAT", e);
    setCustomVAT((prev) => ({
      ...prev,
      [itemKey]: e,
    }));
  };

  const handleCustomInputChange = (e, itemKey) => {
    const value = e.target.value.replace("%", "").trim();
    setCustomVAT((prev) => ({
      ...prev,
      [itemKey]: value,
    }));
    handleOnChangeVAT(value, itemKey);
  };

  const Popup = ({ itemId }) => {
    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "94px",
            width: "160px",
          }}
        >
          <div className="">
            <div className="popover-loader"></div>
            <div className="popover-loader-text">{t("loading")}</div>
          </div>
        </div>
      );
    }
    if (!data || !description) {
      return null;
    }
    return (
      <div className="col-md-12 text-start px-0 mt-3 position-relative">
        <div className="history-header">
          <h1 className="fs16 text-blue-a poppins-medium">{data}</h1>
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-3"
            aria-label="Close"
            onClick={() => handleClosePopup(itemId)}
            style={{
              filter: "brightness(80%)",
            }}
          ></button>
          <h3 className="fs12 cell-gray my-2 pb-1"> {t("medicineDescription")}</h3>
          <div
            style={{ borderBottom: "1px solid #EBEEF2", marginBottom: "10px" }}
          ></div>
          <div className="row">
            {Object.entries(description.medicine_description).map(([key, value]) => (
                <div className="col-sm-6" key={key}>
                <p className="fs12 dark-text poppins-medium mb-2">{t(`${key}`)}</p>
                  {Array.isArray(value) ? (
                    <ul>
                      {value.map((item, index) => (
                        <li className="fs11 medicine-description-popup-values" key={index}>
                          - {item}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="fs11 medicine-description-popup-values">- {value}</p>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  };

  const fetchMedicineInfo = async (name, itemId) => {
    try {
      setLoading(true);
      let payload = {};
      let endpoint = `${environment.baseApi}/document/medicine`;
      payload = {
        id: id,
        extractedInvoiceData: extracted_invoice_data,
        pageNo: selectedPage - 1,
        treatmentOrder: treatmentIndex,
        itemOrder: itemId,
        medicineName: name,
        language: currentLanguage
      };
      const token = sessionStorage.getItem("authToken");

      const headers = {
        "Content-Type": "application/json",
      };
      if (token) {
        headers.Authorization = token;
      }
      const response = await axios.post(endpoint, payload, {
        headers,
      });
      if (response.status !== 200) {
        if (response.status === 401) {
          notification.error({
            message: t("accessDenied"),
            description: t("tokenExpired"),
          });
          forceLogout(response.status);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
      }
      setLoading(false);
      if (!response || response.data.result.error) {
        throw new Error(
          "Invalid response data or missing medicine description"
        );
      }
      let enableItemClassification = environment.enableItemClassification;
      let result = {
        medicine_description: {},
      };
      result.medicine_description["purpose"] =
        response.data.result.medicine_description.purpose;
      result.medicine_description["usedFor"] =
        response.data.result.medicine_description.used_for;
      result.medicine_description["petTypes"] =
        response.data.result.medicine_description.pet_types;
      result.medicine_description["activeIngredients"] =
        response.data.result.medicine_description.active_ingredients;

      if (enableItemClassification) {
        result.medicine_description["category"] =
          response.data.result.medicine_description.category;
        result.medicine_description["typeOfDamage"] =
          response.data.result.medicine_description.type_of_damage;
        result.medicine_description["causeOfDamage"] =
          response.data.result.medicine_description.cause_of_damage;
      }

      setDescription(result);
    } catch (error) {
      console.error("Error fetching medicine information:", error);
      setLoading(false);
    }
  };

  

  const invalidChars = [
    "+",
    "e",
    "E",
    ",",
    " ",
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "_",
    "=",
    "{",
    "}",
    "[",
    "]",
    "|",
    "\\",
    ":",
    ";",
    "'",
    '"',
    "<",
    ">",
    "?",
    "/",
    "~",
    "`",
    "a",
    "b",
    "c",
    "d",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "A",
    "B",
    "C",
    "D",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  const handleKeyDown = (e) => {
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleInputKeyDown = (e) => {
    const invalidChars = [
      "+",
      "e",
      "E",
      ",",
      " ",
      "!",
      "@",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "(",
      ")",
      "_",
      "=",
      "{",
      "}",
      "[",
      "]",
      "|",
      "\\",
      ":",
      ";",
      "'",
      '"',
      "<",
      ">",
      "?",
      "/",
      "~",
      "`",
      "a",
      "b",
      "c",
      "d",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "A",
      "B",
      "C",
      "D",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    console.log(invalidChars.includes(e.key), "invalidChars.includes(e.key)==");
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleClosePopup = (itemId) => {
    setSelectedMedicine(null);
    setOpenPopups((prevState) => ({
      ...prevState,
      [itemId]: false,
    }));
  };

  const handleImageClick = (itemId, itemName) => {
    setSelectedMedicine(itemId);
    setOpenPopups((prevState) => ({
      ...prevState,
      [itemId]: true,
    }));
    setData(itemName);
    fetchMedicineInfo(itemName, itemId);
  };

  return (
    <>
      <Droppable droppableId={String(treatmentId)} type="line-item">
        {(provided) => (
          <div ref={provided.innerRef}>
            {treatments.Items.map((item, index) => (
              <Draggable
                key={`${item.key}`}
                draggableId={`${item.key}`}
                index={index}
                isDragDisabled={isEdit}
              >
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.draggableProps}>
                      <div
                        className="row mb10 align-items-center"
                        key={item.item_order}
                      >
                        <div className="col-1 text-center ps-0 pl0 pr0 pt8 d-flex align-items-center justify-content-center gap-1">
                          <span
                            {...provided.dragHandleProps}
                          >
                            <img
                              src={drag}
                              alt="Drag"
                              className="pt-md-0 pt-0"
                            />
                          </span>
                        </div>
                        <div className="col-auto px-0 d-flex align-items-center">
                          <Checkbox
                            checked={
                              selectedItems &&
                              selectedItems.some(
                                (sel) =>
                                  sel.treatmentKey === treatmentId &&
                                  sel.itemKey === item.key
                              )
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              if (handleToggleItemSelection && !isEdit) {
                                handleToggleItemSelection(
                                  treatmentId,
                                  item.key
                                );
                              }
                            }}
                            disabled={isEdit}
                            style={{ margin: 0 }}
                          />
                        </div>
                        <div className="col-md-4 position-relative">
                          <span className="time-gray fs12 poppins-medium mb5 mt10 d-inline-flex d-md-none pl25">
                            {t("itemName")}
                          </span>
                          <div className="d-flex align-items-center">
                            <Input
                              name="Item Name"
                              placeholder={t("itemName")}
                              value={item["Item Name"]}
                              onChange={(e) =>
                                handleOnChangeItem(
                                  treatmentId,
                                  item.key,
                                  e.target.name,
                                  e.target.value
                                )
                              }
                              className={`${
                                item["Item Name"]?.trim() === "" ||
                                item["Item Name"] === null
                                  ? "bg-invoiceorange"
                                  : ""
                              } ${
                                item.isNew ? "treatment-addnew-row" : ""
                              }`.trim()}
                              disabled={isEdit}
                            />
                            <Popover
                              content={<Popup itemId={index} />}
                              trigger="click"
                              open={openPopups[index]}
                            >
                              <Tooltip
                                title={t("medicine_info")}
                                placement="bottom"
                              >
                                {environment.APP_ENVIRONMENT !==
                                "production" ? (
                                  selectedMedicine === index ? (
                                    <img
                                      className="medicine-info cursor-pointer"
                                      src={selected_question}
                                      alt="question"
                                      onClick={() =>
                                        handleImageClick(
                                          index,
                                          item["Item Name"]
                                        )
                                      }
                                    />
                                  ) : (
                                    <img
                                      className="medicine-info cursor-pointer"
                                      src={ph_question}
                                      alt="selected_question"
                                      onClick={() =>
                                        handleImageClick(
                                          index,
                                          item["Item Name"]
                                        )
                                      }
                                    />
                                  )
                                ) : null}
                              </Tooltip>
                            </Popover>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-11">
                              <div className="row">
                                <div className="col-md-4">
                                  <span className="time-gray fs12 poppins-medium mb5 mt10 d-inline-flex d-md-none">
                                    {t("quantity")}
                                  </span>
                                  <Input
                                    name={"Item Quantity"}
                                    placeholder={t("quantity")}
                                    value={item["Item Quantity"]}
                                    min={0}
                                    onChange={(e) =>
                                      handleOnChangeItem(
                                        treatmentId,
                                        item.key,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                    className={`${
                                      item["Item Quantity"]?.trim() === "" ||
                                      item["Item Quantity"] === null
                                        ? "bg-invoiceorange"
                                        : ""
                                    } ${
                                      item.isNew ? "treatment-addnew-row" : ""
                                    }`.trim()}
                                    disabled={isEdit}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <span className="time-gray fs12 poppins-medium mb5 mt10 d-inline-flex d-md-none">
                                    {t("prize")}
                                  </span>
                                  <Input
                                    name="Item Price"
                                    type="text"
                                    min={0}
                                    placeholder={t("prize")}
                                    value={item["Item Price"]}
                                    onChange={(e) =>
                                      handleOnChangeItem(
                                        treatmentId,
                                        item.key,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                    onKeyDown={handleKeyDown}
                                    className={`${
                                      item["Item Price"]?.toString()?.trim() ===
                                        "" || item["Item Price"] === null
                                        ? "bg-invoiceorange"
                                        : ""
                                    } ${
                                      item?.isNew ? "treatment-addnew-row" : ""
                                    }`?.trim()}
                                    disabled={isEdit}
                                  />
                                </div>
                                <div className="col-md-4 vat-select-option">
                                  <span className="time-gray fs12 poppins-medium mb5 mt10 d-inline-flex d-md-none">
                                    {t("VAT")}
                                  </span>
                                  <Select
                                    value={item["VAT"]}
                                    name={"VAT"}
                                    placeholder={t("VAT")}
                                    onChange={(e) =>
                                      handleOnChangeVAT(e, item.key)
                                    }
                                    className={`${
                                      item["VAT"]?.trim() === "" ||
                                      item["VAT"] === null
                                        ? "bg-invoiceorange"
                                        : ""
                                    } ${
                                      item.isNew
                                        ? "treatment-addnew-select"
                                        : ""
                                    }`.trim()}
                                    dropdownRender={(menu) => (
                                      <>
                                        {menu}
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "8px",
                                          }}
                                        >
                                        <Tooltip title={t("customVAT")} placement="bottom">
                                          <Input
                                            style={{ flex: "auto" }}
                                            value={customVAT[item.key]}
                                            onChange={(e) =>
                                              handleCustomInputChange(
                                                e,
                                                item.key
                                              )
                                            }
                                            placeholder={t("customVAT")}
                                            disabled={isEdit}
                                            onKeyDown={(e) =>
                                              handleInputKeyDown(e, item.key)
                                            }
                                          />
                                          </Tooltip>
                                        </div>
                                      </>
                                    )}
                                    options={[
                                      {
                                        value: null,
                                        label: t("none"),
                                      },
                                      {
                                        value: "2.5",
                                        label: "2.5%",
                                      },
                                      {
                                        value: "2.6",
                                        label: "2.6%",
                                      },
                                      {
                                        value: "7.7",
                                        label: "7.7%",
                                      },
                                      {
                                        value: "8.1",
                                        label: "8.1%",
                                      },
                                    ]}
                                    disabled={isEdit}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-1 text-center ps-0 pt8 d-flex align-items-center justify-content-center gap-2">
                              <Tooltip
                                title={t("deleteItem")}
                                placement="bottom"
                              >
                                <img
                                  src={trash}
                                  alt="trash"
                                  className={`trash-icon ${
                                    !isEdit ? "cursor-pointer" : "is_disabled"
                                  }`}
                                  onClick={(e) =>
                                    handleConfirmationPopup(
                                      "line-item",
                                      treatmentId,
                                      item.key
                                    )
                                  }
                                />
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
    </>
  );
};

export default LineItem;
